import { computed, IComputedValue } from 'mobx';
import { EventsCacheLockId } from 'owa-events-cache';
import { FullItemInfo, FullItemLoadState } from '../store/schema/FullItemsMruMap';
import { getStore } from '../store/store';

export type AllFullItemInfo = { [eventKey: string]: FullItemInfo };

export function getAllFullItemInfo() {
    return allFullItemInfoComputed.get();
}

export function getFullItemInfoFromMRU(eventKey: string): FullItemInfo | null {
    const allFullItemInfo = getAllFullItemInfo();

    return allFullItemInfo[eventKey] || null;
}

export function getFullItemInfoForLockMRU(
    lockId: EventsCacheLockId,
    eventKey: string
): FullItemInfo | null {
    const store = getStore();

    const lockMru = store.fullItemsMruMap.get(lockId);

    if (lockMru) {
        const [fullItemInfo] = lockMru.eventInfos.filter(e => e.eventKey === eventKey);

        return fullItemInfo || null;
    }

    return null;
}

export function getFullItemLoadState(eventKey: string): FullItemLoadState {
    const info = getFullItemInfoFromMRU(eventKey);
    if (info) {
        return info.loadState;
    } else {
        return null;
    }
}

const allFullItemInfoComputed: IComputedValue<AllFullItemInfo> = computed(() => {
    const store = getStore();

    return [...store.fullItemsMruMap.keys()].reduce<AllFullItemInfo>((agg, lockId) => {
        const { eventInfos } = store.fullItemsMruMap.get(lockId);

        eventInfos.forEach(ei => (agg[ei.eventKey] = ei));

        return agg;
    }, {});
});
